import { render, staticRenderFns } from "./KedvezmenyekB11.vue?vue&type=template&id=c91137aa&"
import script from "./KedvezmenyekB11.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports